import React from "react";
import { IOfferCardProps } from "../SimpleOfferCard";
import cx from "classnames";
import CheckMark from "../../../resources/icons/payments/checkmark-round.svg";
import dynamic from "next/dynamic";
import { useHandlePayment } from "../../../screens/PaymentScreen/hooks/useCreatePaymentLinks";
import { useTranslation } from "next-i18next";

const MediaButton = dynamic<any>(() =>
  import("components/MediaButton/MediaButton").then((mod) => mod.MediaButton)
);

const isAnnualPeriod = (period: string) => period === "year";

export const ButtonContainer: React.FC<IOfferCardProps> = ({
  offer,
  active,
  buttonCallbackAction,
  displayMode,
}) => {
  const goToPaymentDetails = useHandlePayment();
  const { t } = useTranslation("translations");

  return (
    <div className={"CTAButtonContainer"}>
      {displayMode === "choose" ? (
        <>
          <MediaButton
            className={cx("SimpleOfferCardButton")}
            variant="primary"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              buttonCallbackAction
                ? buttonCallbackAction()
                : goToPaymentDetails(offer.Id);
            }}
          >
            {t("web_choose_subscription", "")}
          </MediaButton>
          <span className={"OfferDesc"}>
            {isAnnualPeriod(offer.Period)
              ? t("web_choose_subscription_annual_usp", "")
              : t("web_landing_page__features__price_desc", "")}
          </span>
        </>
      ) : active ? (
        <>
          <div className={"VoucherSuccess"}>
            <span>
              <CheckMark /> {t("web_subscription_change_current_plan", "")}
            </span>
          </div>
        </>
      ) : (
        <>
          <MediaButton
            className={cx("SimpleOfferCardButton")}
            variant="primary"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              buttonCallbackAction
                ? buttonCallbackAction()
                : goToPaymentDetails(offer.Id);
            }}
          >
            {t("web_subscription_change_button", "")}
          </MediaButton>
          <span className={"OfferDesc"}>
            {isAnnualPeriod(offer.Period)
              ? t("web_choose_subscription_annual_usp", "")
              : t("web_landing_page__features__price_desc", "")}
          </span>
        </>
      )}
    </div>
  );
};
